'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _loadingSpinner = require('../loading-spinner');

var _loadingSpinner2 = _interopRequireDefault(_loadingSpinner);

var _styledText = require('../styled-text');

var _styledText2 = _interopRequireDefault(_styledText);

require('./button.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var STYLE_BASE = 'zk-button-';

var getContent = function getContent(_ref) {
  var title = _ref.title,
      children = _ref.children,
      loading = _ref.loading,
      secondary = _ref.secondary,
      _ref$useStyledText = _ref.useStyledText,
      useStyledText = _ref$useStyledText === undefined ? true : _ref$useStyledText;

  if (loading) {
    return _react2.default.createElement(_loadingSpinner2.default, {
      secondary: true,
      className: STYLE_BASE + 'loader'
    });
  }

  var label = void 0;

  if (title) {
    label = title;
  } else if (!label && children && (typeof children === 'string' || children instanceof String)) {
    label = children;
  }

  if (label) {
    if (!useStyledText) {
      return label;
    }

    return _react2.default.createElement(_styledText2.default, {
      className: secondary ? STYLE_BASE + 'label-secondary' : STYLE_BASE + 'label-primary'
    }, label);
  }

  return children;
};

var handleClick = function handleClick(e, _ref2) {
  var disabled = _ref2.disabled,
      loading = _ref2.loading,
      onPress = _ref2.onPress,
      onClick = _ref2.onClick;

  if (disabled || loading || e.defaultPrevented) {
    return;
  } else if (onPress) {
    onPress(e);
  } else if (onClick) {
    onClick(e);
  }
};

var Button = _react2.default.forwardRef(function (props, ref) {
  var _classNames;

  var altTag = props.altTag,
      className = props.className,
      dangerous = props.dangerous,
      disabled = props.disabled,
      large = props.large,
      isLinkStyle = props.isLinkStyle,
      secondary = props.secondary,
      square = props.square,
      testid = props.testid,
      titleTag = props.titleTag,
      transparent = props.transparent,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === undefined ? 0 : _props$tabIndex,
      _props$type = props.type,
      type = _props$type === undefined ? 'button' : _props$type,
      rest = _objectWithoutProperties(props, ['altTag', 'className', 'dangerous', 'disabled', 'large', 'isLinkStyle', 'secondary', 'square', 'testid', 'titleTag', 'transparent', 'tabIndex', 'type']);

  var restProps = (0, _omit2.default)(rest, [].concat(_toConsumableArray(Object.keys(Button.propTypes)), ['className']));
  var primary = !secondary && !dangerous && !transparent && !isLinkStyle;
  return _react2.default.createElement('button', _extends({
    alt: altTag,
    className: (0, _classnames2.default)((_classNames = {
      'zk-button': true
    }, _defineProperty(_classNames, STYLE_BASE + 'square-button-width', square), _defineProperty(_classNames, STYLE_BASE + 'large-button-height', large), _defineProperty(_classNames, STYLE_BASE + 'primary', primary), _defineProperty(_classNames, STYLE_BASE + 'secondary', secondary), _defineProperty(_classNames, STYLE_BASE + 'dangerous', dangerous), _defineProperty(_classNames, STYLE_BASE + 'transparent', transparent), _defineProperty(_classNames, STYLE_BASE + 'linkStyle', isLinkStyle), _defineProperty(_classNames, className, !!className), _classNames)),
    'data-testid': testid,
    disabled: disabled,
    onClick: function onClick(e) {
      return handleClick(e, props);
    },
    ref: ref,
    tabIndex: tabIndex,
    title: titleTag,
    type: type
  }, restProps), getContent(props));
});

Button.propTypes = {
  altTag: _propTypes2.default.string,
  dangerous: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  isLinkStyle: _propTypes2.default.bool,
  large: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  onPress: _propTypes2.default.func,
  primary: _propTypes2.default.bool,
  secondary: _propTypes2.default.bool,
  square: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  titleTag: _propTypes2.default.string,
  transparent: _propTypes2.default.bool,
  useStyledText: _propTypes2.default.bool
};
exports.default = Button;